export default __webpack_public_path__ + "1e1a93c2bf8ae63f21fa043332f95181.jpg";